<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleAdd"><a-icon type="plus" />新增展示卡</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-alert
        message="编辑时修改展示价格后，涨跌幅将按「(新价格 - 当前展示价格) / 当前展示价格 × 100%」自动计算；新增时请手动填写。"
        type="info"
        show-icon
        style="margin-bottom: 16px"
      />
      <a-table :loading="loading" rowKey="id" :columns="columns" :data-source="list" :pagination="false">
        <span slot="logoUrl" slot-scope="text">
          <img v-if="text" :src="text" style="width:40px;height:40px;object-fit:cover;border-radius:50%" />
          <span v-else>—</span>
        </span>
        <span slot="categoryId" slot-scope="text">
          {{ categoryName(text) }}
        </span>
        <span slot="displayPrice" slot-scope="text, record">
          {{ record.currencySymbol || '₦' }} {{ text }}
        </span>
        <span slot="trendPercent" slot-scope="text">
          <span v-if="text > 0" style="color:#52c41a">↑ {{ text }}%</span>
          <span v-else-if="text < 0" style="color:#f5222d">↓ {{ Math.abs(text) }}%</span>
          <span v-else>0%</span>
        </span>
        <span slot="status" slot-scope="text">
          <a-tag v-if="text === 1" color="green">启用</a-tag>
          <a-tag v-else color="red">禁用</a-tag>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="handleDelete(record)">删除</a>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        @change="changePage"
      />
    </a-card>

    <a-modal :title="formTitle" :visible="open" @ok="submitForm" @cancel="open = false" :confirmLoading="submitLoading">
      <a-form-model :model="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item label="关联卡种" required>
          <a-select
            v-model="form.categoryId"
            show-search
            option-filter-prop="children"
            placeholder="选择卡种（App 展示名称与跳转回显）"
            style="width:100%"
          >
            <a-select-option v-for="c in categoryOptions" :key="c.id" :value="c.id">
              {{ c.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="Logo">
          <file-upload v-model="form.logoUrl" type="image" @change="val => (form.logoUrl = val)" />
          <div style="color:#999;font-size:12px">不填则 App 使用卡种 Logo</div>
        </a-form-model-item>
        <a-form-model-item label="展示价格" required>
          <a-input-number
            v-model="form.displayPrice"
            :min="0"
            :precision="2"
            style="width:100%"
            @change="onDisplayPriceChange"
          />
        </a-form-model-item>
        <a-form-model-item label="涨跌幅 %" required>
          <a-input-number v-model="form.trendPercent" :precision="2" style="width:100%" placeholder="如 1.75 或 -1.75" />
          <div v-if="isEdit && editBasePrice != null" style="color:#999;font-size:12px">
            原价格 {{ form.currencySymbol || '₦' }}{{ editBasePrice }}，修改展示价格后自动换算；也可手动微调
          </div>
          <div v-else style="color:#999;font-size:12px">正数显示上涨 ↑，负数显示下跌 ↓</div>
        </a-form-model-item>
        <a-form-model-item label="货币符号">
          <a-input v-model="form.currencySymbol" placeholder="默认 ₦" />
        </a-form-model-item>
        <a-form-model-item label="排序">
          <a-input-number v-model="form.sort" :min="0" style="width:100%" />
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-select v-model="form.status" style="width:100%">
            <a-select-option :value="1">启用</a-select-option>
            <a-select-option :value="0">禁用</a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import { pageHomeGiftCard, saveHomeGiftCard, deleteHomeGiftCard } from '@/api/giftcard/homeGiftCard'
import { pageCategory } from '@/api/giftcard/category'

export default {
  name: 'GiftcardHomeGiftCard',
  data() {
    return {
      loading: false,
      submitLoading: false,
      open: false,
      formTitle: '',
      list: [],
      total: 0,
      categoryOptions: [],
      queryParam: { pageNum: 1, pageSize: 10 },
      form: {
        id: null,
        categoryId: undefined,
        logoUrl: '',
        displayPrice: 0,
        prevPrice: null,
        trendPercent: 0,
        currencySymbol: '₦',
        sort: 0,
        status: 1
      },
      /** 编辑时用于换算涨跌幅的原价格（打开编辑时的当前展示价） */
      editBasePrice: null,
      columns: [
        { title: 'ID', dataIndex: 'id', width: 70 },
        { title: '关联卡种', dataIndex: 'categoryId', scopedSlots: { customRender: 'categoryId' }, width: 140 },
        { title: 'Logo', dataIndex: 'logoUrl', scopedSlots: { customRender: 'logoUrl' }, width: 80 },
        { title: '展示价格', dataIndex: 'displayPrice', scopedSlots: { customRender: 'displayPrice' }, width: 120 },
        { title: '涨跌幅', dataIndex: 'trendPercent', scopedSlots: { customRender: 'trendPercent' }, width: 100 },
        { title: '排序', dataIndex: 'sort', width: 70 },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, width: 80 },
        { title: '操作', scopedSlots: { customRender: 'operation' }, width: 120 }
      ]
    }
  },
  computed: {
    isEdit() {
      return this.form.id != null
    }
  },
  created() {
    this.loadCategories()
    this.getList()
  },
  methods: {
    loadCategories() {
      pageCategory({ pageNum: 1, pageSize: 200, status: 1 }).then(res => {
        this.categoryOptions = (res.data && res.data.records) || []
      })
    },
    categoryName(categoryId) {
      if (!categoryId) return '—'
      const item = this.categoryOptions.find(c => c.id === categoryId)
      return item ? item.name : categoryId
    },
    getList() {
      this.loading = true
      pageHomeGiftCard(this.queryParam).then(res => {
        this.list = res.data.records || []
        this.total = res.data.total || 0
      }).finally(() => { this.loading = false })
    },
    changePage(page, pageSize) {
      this.queryParam.pageNum = page
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    resetForm() {
      this.editBasePrice = null
      this.form = {
        id: null,
        categoryId: undefined,
        logoUrl: '',
        displayPrice: 0,
        prevPrice: null,
        trendPercent: 0,
        currencySymbol: '₦',
        sort: 0,
        status: 1
      }
    },
    /** (新价格 - 原价格) / 原价格 × 100，保留两位小数 */
    calcTrendPercent(newPrice, basePrice) {
      if (newPrice == null || basePrice == null || Number(basePrice) === 0) {
        return null
      }
      const pct = ((Number(newPrice) - Number(basePrice)) / Number(basePrice)) * 100
      return Math.round(pct * 100) / 100
    },
    onDisplayPriceChange() {
      if (!this.isEdit || this.editBasePrice == null || Number(this.editBasePrice) === 0) {
        return
      }
      const pct = this.calcTrendPercent(this.form.displayPrice, this.editBasePrice)
      if (pct != null) {
        this.form.trendPercent = pct
      }
    },
    handleAdd() {
      this.resetForm()
      this.formTitle = '新增展示卡'
      this.open = true
    },
    handleEdit(record) {
      const display = record.displayPrice != null ? Number(record.displayPrice) : null
      this.editBasePrice = display != null && display > 0 ? display : null
      this.form = {
        ...record,
        categoryId: record.categoryId,
        prevPrice: record.prevPrice,
        trendPercent: record.trendPercent != null ? record.trendPercent : 0,
        currencySymbol: record.currencySymbol || '₦'
      }
      this.formTitle = '编辑展示卡'
      this.open = true
    },
    submitForm() {
      if (!this.form.categoryId) {
        this.$message.warning('请选择关联卡种')
        return
      }
      if (this.form.displayPrice == null || this.form.displayPrice < 0) {
        this.$message.warning('请填写展示价格')
        return
      }
      if (this.form.trendPercent == null) {
        this.$message.warning('请填写涨跌幅')
        return
      }
      this.submitLoading = true
      saveHomeGiftCard(this.form).then(() => {
        this.$message.success('保存成功')
        this.open = false
        this.getList()
      }).finally(() => { this.submitLoading = false })
    },
    handleDelete(record) {
      const self = this
      this.$confirm({
        title: '确认删除该展示卡？',
        onOk() {
          return deleteHomeGiftCard(record.id).then(() => {
            self.$message.success('删除成功')
            self.getList()
          })
        }
      })
    }
  }
}
</script>
